import React, { useState, useEffect } from "react";
import { useProductFlow, PRODUCT_MANAGEMENT } from "../utils/product-flow";
import ComparePlans from "../components/pricing/price_compare";
import PricingPlan from "../components/pricing/plans";
import PricingTrust from "../components/pricing/pricing-trust";
import PricingTestimonials from "../components/pricing/pricing-testimonials";
import Footer from "../components/footer";
import FAQS from "../components/pricing/pricing-faq";
import HeaderAny from "../components/header";
import MobileNav from "../components/header-mobile";

const Pricing = () => {
    const { product } = useProductFlow();
    const flowTab = product === PRODUCT_MANAGEMENT ? "management" : "publishing";
    const [activeTab, setActiveTab] = useState(flowTab);

    // Keep pricing in sync with the visitor's product flow
    useEffect(() => setActiveTab(flowTab), [flowTab]);

    return (
        <div>
            <div>
                <div className="web-only">
                    <HeaderAny />
                </div>
                <div className="mobile-only">
                    <MobileNav />
                </div>
            </div>
            <PricingPlan activeTab={activeTab} setActiveTab={setActiveTab} />
            <ComparePlans activeTab={activeTab} />
            <PricingTrust />
            {/* <div className="pricing-testimonial-heading">
                <p className="pricing-testimonial-italic">What our client say</p>
                <h2 className="pricing-testimonial-title">Trusted by Global Leaders</h2>
            </div>
            <PricingTestimonials /> */}
            <FAQS />
            <Footer />
        </div>
    );
};

export default Pricing;
